import { Component } from '@angular/core';

@Component({
  selector: 'app-private-pages',
  templateUrl: './private-pages.component.html',
  styleUrls: ['./private-pages.component.scss'],
})
export class PrivatePagesComponent {}
